<template>
  <material-card v-if="$store.state.menu.Users" class="card-tabs" color="#004D40">
    <v-flex slot="header">
      <v-tabs v-model="tabs" color="transparent" slider-color="white">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account-plus</v-icon>Новые
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account</v-icon>Продавцы
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account</v-icon>Партнеры
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account-star</v-icon>Субдистрибьюторы
        </v-tab>
      </v-tabs>
    </v-flex>
    <v-tabs-items>
      <v-tab-item>
        <div class="tab-products">
          <UsersList :role="null" :no_role="1" v-if="tabs===0" />
          <UsersList :role="1" v-else-if="tabs===1" />
          <UsersList :role="3" v-else-if="tabs===2" />
          <UsersList :role="2" v-else-if="tabs===3" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </material-card>
</template>
<script>
import UsersList from "../components/core/UsersList";

export default {
  components: {
    UsersList
  },
  data() {
    return {
      tabs: -1
    };
  },
  methods: {},
  mounted() {
    this.tabs = 0;
  },
  computed: {}
};
</script>

<style>
.tab-products {
  min-height: 70vh;
}
</style>